import { MarkerType } from 'react-flow-renderer';

export const FLOW_CHART_CLASS_NAME = 'guardrails-flow-chart';
export const FLOW_CHART_NODE_CLASS_NAME = `${FLOW_CHART_CLASS_NAME}__node`;
export const FLOW_CHART_NODE_MESSAGE_CLASS_NAME = `${FLOW_CHART_NODE_CLASS_NAME}_message`;
export const FLOW_CHART_NODE_ACTION_CLASS_NAME = `${FLOW_CHART_NODE_CLASS_NAME}_action`;
export const FLOW_CHART_NODE_EXTERNAL_ACTION_CLASS_NAME = `${FLOW_CHART_NODE_CLASS_NAME}_external-action`;
export const FLOW_CHART_STAGE_CLASS_NAME = `${FLOW_CHART_CLASS_NAME}__stage`;
export const FLOW_CHART_STAGE_TITLE_CLASS_NAME = `${FLOW_CHART_STAGE_CLASS_NAME}__title`;
export const FLOW_CHART_STAGE_STEPS_CLASS_NAME = `${FLOW_CHART_STAGE_CLASS_NAME}__steps`;
export const FLOW_CHART_STEP_CLASS_NAME = `${FLOW_CHART_CLASS_NAME}__step`;
export const FLOW_CHART_STEP_DISABLED_CLASS_NAME = `${FLOW_CHART_STEP_CLASS_NAME}_disabled`;
export const FLOW_CHART_STEP_INDEX_CLASS_NAME = `${FLOW_CHART_STEP_CLASS_NAME}__index`;
export const FLOW_CHART_STEP_TITLE_CLASS_NAME = `${FLOW_CHART_STEP_CLASS_NAME}__title`;
export const FLOW_CHART_STEP_ADD_CLASS_NAME = `${FLOW_CHART_STEP_CLASS_NAME}__add`;
export const FLOW_CHART_EMPTY_CLASS_NAME = `${FLOW_CHART_CLASS_NAME}__empty`;
export const FLOW_CHART_HANDLE_CLASS_NAME = `${FLOW_CHART_CLASS_NAME}__handle`;
export const FLOW_CHART_NO_INTERACTION_CLASS_NAME = `${FLOW_CHART_CLASS_NAME}__no-interaction`;

export const FLOW_STAGE_WIDTH = 680;
export const FLOW_STAGE_COMPACT_WIDTH = 464;
export const FLOW_NODE_WIDTH = 140;
export const FLOW_ACTION_NODE_WIDTH = 170;
export const FLOW_DEMASKING_X_POSITION = 908;
export const FLOW_CHART_MIN_ZOOM = 0.1;
export const FLOW_CHART_MAX_ZOOM = 1.25;
export const FLOW_CHART_LEFT_PADDING = 16;
export const FLOW_CHART_FIT_VIEW_OPTIONS = {
  padding: 0.02,
  minZoom: FLOW_CHART_MIN_ZOOM,
  maxZoom: FLOW_CHART_MAX_ZOOM,
};

export const defaultEdgeOptions = {
  type: 'smoothstep',
  style: { stroke: '#C8C8C8', strokeWidth: 1.5 },
  markerEnd: { type: MarkerType.ArrowClosed, color: '#C8C8C8', width: 16, height: 16 },
};
